module.exports = __webpack_public_path__ + "img/computer.9c8888f7.svg";